import React from 'react';
import { createStackNavigator } from '@react-navigation/stack';

import LogoTitle from '@src/components/LogoTitle';
import useStackScreenOptions from '@src/hooks/useStackScreenOptions';
import DummyExploreScreen from '@src/screens/DummyExplore';
import DummyPostScreen from '@src/screens/DummyPost';

import { DummyDashboardStackParamList } from './types';

const Stack = createStackNavigator<DummyDashboardStackParamList>();

const Component: React.FC = () => {
  const stackScreenOptions = useStackScreenOptions();

  return (
    <Stack.Navigator
      headerMode="screen"
      screenOptions={{
        ...stackScreenOptions,
        headerTitle: () => <LogoTitle />,
        headerTitleAlign: 'center',
        headerBackTitle: '',
        headerTruncatedBackTitle: '',
      }}
    >
      <Stack.Screen name="DummyExplore" component={DummyExploreScreen} />
      <Stack.Screen name="DummyPost" component={DummyPostScreen} />
    </Stack.Navigator>
  );
};

Component.displayName = 'DummyDashboardStack';

export default Component;
